import { render } from "./robot.vue?vue&type=template&id=232e5ec8&scoped=true"
import script from "./robot.vue?vue&type=script&lang=js"
export * from "./robot.vue?vue&type=script&lang=js"

import "./robot.vue?vue&type=style&index=0&id=232e5ec8&lang=scss&scoped=true"

import exportComponent from "/home/jenkins-prod/worker1/workspace/jaka-digital/A-01-OTA/jaka-ota-admin-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-232e5ec8"]])

export default __exports__